module.exports = __webpack_public_path__ + "img/how_it_work_en.b76d6b6d.png";